/*!
 * article-toc.js — v4.10 (2026-05-30) L 案 マガジンカバー型目次
 *   - H2 のみカード化（H3 サブ見出しは生成しない）
 *   - 4 色ループ（amber / burgundy / gold / deep brown）
 *   - ジャンルラベル自動割当（PROLOGUE / FEATURE / SPECIAL / GUIDE）
 *   - 「＋」展開ボタン廃止
 *   - 既存の .lx-toc（Metaobject body HTML）/ .article-toc（旧 C3）は CSS 側で非表示。本 JS は新規挿入のみ担当。
 *   - WordPress 記事（main-wp-article.liquid）は本文 fetch 後に DOM 注入されるため MutationObserver で再 init。
 */
(function () {
  'use strict';

  var COVER_CLASSES = [
    'lx-toc-magazine__cover--c1',
    'lx-toc-magazine__cover--c2',
    'lx-toc-magazine__cover--c3',
    'lx-toc-magazine__cover--c4'
  ];
  var GENERIC_CATS = ['本章', '概要', '比較', '解説'];

  function slugify(text, idx) {
    if (!text) return 'toc-h-' + idx;
    var clean = text.toString()
      .trim()
      .replace(/[\s]+/g, '-')
      .replace(/[^\w\-぀-ゟ゠-ヿ一-鿿]/g, '')
      .substring(0, 40);
    return 'toc-h-' + idx + (clean ? '-' + clean : '');
  }

  function pad2(n) { return n < 10 ? '0' + n : String(n); }

  function pickLabel(i, total) {
    // 1 → PROLOGUE / 最後 → GUIDE / 中央付近 → FEATURE / それ以外 → SPECIAL
    if (i === 1) return 'PROLOGUE';
    if (i === total) return 'GUIDE';
    var mid = Math.ceil(total / 2);
    if (i === mid) return 'FEATURE';
    return 'SPECIAL';
  }

  function splitTitle(title) {
    // 「｜」「|」「：」「:」を区切りに、前半 = category、後半 = 本タイトルとする
    if (!title) return { cat: '', body: '' };
    var seps = ['｜', '|', '：', ':'];
    for (var i = 0; i < seps.length; i++) {
      var s = seps[i];
      var idx = title.indexOf(s);
      if (idx > 0 && idx < title.length - 1) {
        return {
          cat: title.substring(0, idx).trim(),
          body: title.substring(idx + s.length).trim()
        };
      }
    }
    return { cat: '', body: title.trim() };
  }

  function buildCard(item, idx, total) {
    var n = idx + 1;
    var li = document.createElement('li');
    li.className = 'lx-toc-magazine__item';

    var a = document.createElement('a');
    a.className = 'lx-toc-magazine__card';
    a.href = '#' + item.id;

    // 左カバー
    var cover = document.createElement('div');
    cover.className = 'lx-toc-magazine__cover ' + COVER_CLASSES[(n - 1) % 4];

    var num = document.createElement('div');
    num.className = 'lx-toc-magazine__number';
    num.textContent = pad2(n);
    cover.appendChild(num);

    var lbl = document.createElement('div');
    lbl.className = 'lx-toc-magazine__label';
    lbl.textContent = pickLabel(n, total);
    cover.appendChild(lbl);

    a.appendChild(cover);

    // 右ボディ
    var body = document.createElement('div');
    body.className = 'lx-toc-magazine__body';

    var textWrap = document.createElement('div');
    textWrap.className = 'lx-toc-magazine__text';

    var parts = splitTitle(item.text);
    var catText = parts.cat || GENERIC_CATS[(n - 1) % GENERIC_CATS.length];

    var cat = document.createElement('span');
    cat.className = 'lx-toc-l-cat';
    cat.textContent = catText;
    textWrap.appendChild(cat);

    var tt = document.createElement('span');
    tt.className = 'lx-toc-l-title';
    tt.textContent = parts.body || item.text;
    textWrap.appendChild(tt);

    body.appendChild(textWrap);

    var arrow = document.createElement('span');
    arrow.className = 'lx-toc-magazine__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '›';
    body.appendChild(arrow);

    a.appendChild(body);
    li.appendChild(a);
    return li;
  }

  function findArticleRoot() {
    return document.querySelector('.article__content') ||
           document.querySelector('.main-article__content') ||
           document.querySelector('.shopify-article-content') ||
           document.querySelector('.article-content') ||
           document.querySelector('article .rte') ||
           document.querySelector('.template-article .rte') ||
           document.querySelector('.main-wp-article') ||
           document.querySelector('[class*="article"] .rte') ||
           (document.body.classList.contains('template-article')
             ? (document.querySelector('main .rte') || document.querySelector('main article'))
             : null);
  }

  function init() {
    if (document.querySelector('.lx-toc-magazine')) return;

    var article = findArticleRoot();
    if (!article) return;

    var h2s = article.querySelectorAll('h2');
    if (h2s.length < 2) return;

    var items = [];
    Array.prototype.forEach.call(h2s, function (h, i) {
      if (!h.id) h.id = slugify(h.textContent, i);
      h.classList.add('article-toc-target');
      var raw = (h.textContent || '').trim();
      if (!raw) return;
      items.push({ id: h.id, text: raw });
    });
    if (items.length < 2) return;

    var total = items.length;
    var nav = document.createElement('nav');
    nav.className = 'lx-toc-magazine';
    nav.setAttribute('aria-label', '記事の目次');

    var title = document.createElement('div');
    title.className = 'lx-toc-magazine__title';
    title.appendChild(document.createTextNode('目次'));
    nav.appendChild(title);

    var ol = document.createElement('ol');
    ol.className = 'lx-toc-magazine__list';
    items.forEach(function (it, idx) {
      ol.appendChild(buildCard(it, idx, total));
    });
    nav.appendChild(ol);

    var firstH2 = article.querySelector('h2');
    if (firstH2 && firstH2.parentNode) {
      firstH2.parentNode.insertBefore(nav, firstH2);
    } else {
      article.insertBefore(nav, article.firstChild);
    }

    nav.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.lx-toc-magazine__card');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var targetId = href.substring(1);
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      var rect = target.getBoundingClientRect();
      var top = rect.top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (history.pushState) history.pushState(null, '', '#' + targetId);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          var cards = nav.querySelectorAll('.lx-toc-magazine__card');
          cards.forEach(function (c) {
            if (c.getAttribute('href') === '#' + id) {
              c.classList.add('is-active');
              c.setAttribute('aria-current', 'true');
            } else {
              c.classList.remove('is-active');
              c.removeAttribute('aria-current');
            }
          });
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
      items.forEach(function (it) {
        var el = document.getElementById(it.id);
        if (el) io.observe(el);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 50);
  }

  function startObserver() {
    if (!document.body) return;
    var obs = new MutationObserver(function () {
      if (document.querySelector('.lx-toc-magazine')) return;
      var hasH2 = document.querySelector('.article-content h2, .article__content h2, .shopify-article-content h2');
      if (hasH2) init();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
